import * as React from 'react';

import styled, { keyframes } from '../../theme';
import ProjectType from '../../models/ProjectType';
import ProjectContent from './ProjectContent';
import NewsletterSubscription from '../About/NewsletterSubscription';

interface IProps {
  typeProjectsMap: typeof ProjectType.typeProjectsMap;
  projectType: string;
  archived: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-100%);
  }

  to {
    opacity: 1;
    transform: none;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  position: relative;

  @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
    padding-bottom: ${(props) => props.theme.mobilePadding}px;
  }

  @media (min-width: ${(props) => props.theme.mobileBreakpoint}px) {
    padding: 50px 0;
    width: 65%;

    > * {
      margin-bottom: 100px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const SubscriptionContainer = styled.div`
  @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
    margin-top: 50px;
  }
`;

const Border = styled.div`
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  &::before {
    background-color: #ebebeb;
    content: '';
    height: 1px;
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    animation-name: ${fadeIn};
    animation-fill-mode: forwards;
    animation-duration: 0.8s;
    animation-timing-function: ease;
    animation-delay: 0.35s;
    opacity: 0;
    margin: 0;

    @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
      left: ${(props) => props.theme.mobilePadding}px;
      right: ${(props) => props.theme.mobilePadding}px;
      width: auto;
    }
  }
`;

class ProjectList extends React.Component<IProps> {
  render() {
    const allProjects = this.props.typeProjectsMap.get(this.props.projectType);
    if (undefined === allProjects) {
      return null;
    }

    const projects = this.props.archived
      ? allProjects.filter((project) => !!project.fields.archived)
      : allProjects.filter((project) => !project.fields.archived);

    return (
      <Container>
        <Border key={this.props.projectType} />
        {projects.map((project, index) => {
          if (!project.fields) {
            return null;
          }

          const slug = project.fields.slug;

          return (
            <React.Fragment key={slug}>
              <ProjectContent
                projectSlug={slug}
                index={index}
                archived={this.props.archived}
              />
              {index === 0 && (
                <SubscriptionContainer>
                  <NewsletterSubscription />
                </SubscriptionContainer>
              )}
            </React.Fragment>
          );
        })}
      </Container>
    );
  }
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/scenes/Project/ProjectList.tsx